var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineKeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_32980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.28267 0.834053C1.5322 0.884175 0.955078 1.52398 0.955078 2.29615V7.59687C0.955078 8.40893 1.59624 9.06723 2.38714 9.06723H41.7506C42.5415 9.06723 43.1826 8.40893 43.1826 7.59687V2.29615C43.1826 1.52398 42.6055 0.884175 41.855 0.834053C38.3609 0.600683 28.7209 0 22.0689 0C15.4168 0 5.77686 0.600683 2.28267 0.834053ZM18.153 1.29532C17.4562 1.29532 16.8914 1.87525 16.8914 2.59064C16.8914 3.30602 17.4562 3.88596 18.153 3.88596H25.7644C26.4612 3.88596 27.026 3.30602 27.026 2.59064C27.026 1.87525 26.4612 1.29532 25.7644 1.29532H18.153Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.844551 12.4972C0.844551 11.6852 1.48571 11.0269 2.27662 11.0269H41.64C42.431 11.0269 43.0721 11.6852 43.0721 12.4972V25.8184C43.5815 26.1704 43.9167 26.768 43.9167 27.4459C43.9167 28.1238 43.5815 28.7214 43.0721 29.0734V47.3837C43.5815 47.7358 43.9167 48.3333 43.9167 49.0112C43.9167 49.6891 43.5815 50.2867 43.0721 50.6388V60.5291C43.0721 61.3411 42.431 61.9994 41.64 61.9994H2.27662C1.48571 61.9994 0.844551 61.3411 0.844551 60.5291V50.6388C0.335123 50.2867 0 49.6891 0 49.0112C0 48.3333 0.335123 47.7358 0.844551 47.3837V29.0734C0.335123 28.7214 0 28.1238 0 27.4459C0 26.768 0.335123 26.1704 0.844551 25.8184V12.4972ZM5.83675 13.7225C4.47813 13.7225 3.37675 14.8238 3.37675 16.1825V56.3536C3.37675 57.7122 4.47813 58.8136 5.83675 58.8136H38.077C39.4356 58.8136 40.537 57.7122 40.537 56.3536V16.1825C40.537 14.8238 39.4356 13.7225 38.077 13.7225H5.83675Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_839_32980",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 23,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_839_32980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5998 39C20.5998 37.65 20.7206 36.6792 20.9623 36.0875C21.204 35.4958 21.7165 34.85 22.4998 34.15C23.1831 33.55 23.704 33.0292 24.0623 32.5875C24.4206 32.1458 24.5998 31.6417 24.5998 31.075C24.5998 30.3917 24.3706 29.825 23.9123 29.375C23.454 28.925 22.8165 28.7 21.9998 28.7C21.1498 28.7 20.504 28.9583 20.0623 29.475C19.6206 29.9917 19.3081 30.5167 19.1248 31.05L16.5498 29.95C16.8998 28.8833 17.5415 27.9583 18.4748 27.175C19.4081 26.3917 20.5831 26 21.9998 26C23.7498 26 25.0956 26.4875 26.0373 27.4625C26.979 28.4375 27.4498 29.6083 27.4498 30.975C27.4498 31.8083 27.2706 32.5208 26.9123 33.1125C26.554 33.7042 25.9915 34.375 25.2248 35.125C24.4081 35.9083 23.9123 36.5042 23.7373 36.9125C23.5623 37.3208 23.4748 38.0167 23.4748 39H20.5998ZM21.9998 45C21.4498 45 20.979 44.8042 20.5873 44.4125C20.1956 44.0208 19.9998 43.55 19.9998 43C19.9998 42.45 20.1956 41.9792 20.5873 41.5875C20.979 41.1958 21.4498 41 21.9998 41C22.5498 41 23.0206 41.1958 23.4123 41.5875C23.804 41.9792 23.9998 42.45 23.9998 43C23.9998 43.55 23.804 44.0208 23.4123 44.4125C23.0206 44.8042 22.5498 45 21.9998 45Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_32980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineKeg);
export default __webpack_public_path__ + "static/media/offlineKeg.54fe5695176e1b7ab36438f41adfe4ea.svg";
export { ForwardRef as ReactComponent };